import React from 'react';
import { HorizontalBar } from 'react-chartjs-2';
import { translate } from 'react-i18next';
import Card from '../card/Card';

class SavingEnergyConsumptionChart extends React.Component {

  render() {
    const { t } = this.props;
    const data = {
      labels: this.props.projects.map(project => project.name),
      datasets: [
        {
          label: `${t('% saving energy')}`,
          backgroundColor: 'rgba(255,72,0,1)',
          borderColor: 'rgba(255,99,132,1)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgba(255,99,132,0.4)',
          hoverBorderColor: 'rgba(255,99,132,1)',
          maintainAspectRatio: false,
          data: this.props.projects.map(
            ({ evaluation: { whole_building_energy: energy } }, index) => {
              const saving_energy = (energy.compliance - energy.net_EPA) / energy.compliance;
              return saving_energy * 100;
            }
          ),
        },
      ],
    };

    const options = {
      scales: {
        xAxes: [{
            ticks: {
              min: 0,
              max: 100,
            },
        }],
        yAxes: [{
            ticks: {
              callback: function (value, index, values) {
                if (value.length > 20) {
                  return value.substring(0, 20) + '...';
                }
                return value;
              },
            },
        }]
      },
    };
    const height = Math.max(262, this.props.projects.length * 40);
    return (
      <Card header={t('% saving energy')}>
        <HorizontalBar data={data} options={options} height={height} redraw={true}/>
      </Card>
    );
  }
}

export default translate('translations')(SavingEnergyConsumptionChart);



// WEBPACK FOOTER //
// ./src/components/powerconsumptionchart/SavingEnergyConsumptionChart.js